// Modules.
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components.
import ArrowIcon from '../../../ArrowIcon';

// Styles.
import './LoginMenuItem.scss';

const LoginMenuItem = ({ collapsed, gvars }) => {

    const classes = classnames({
        'LoginMenuItem': true,
        'collapsed': collapsed,
    });

    return (
        <div className={ classes }>
            <h5>
                {/* Double-titles for hover-state */}
                <span>{ gvars.login_menu_text }</span>
                <span>{ gvars.login_menu_text }</span>
            </h5>
            <ul className="dropdown">
                {
                    gvars.login_links && gvars.login_links.map((child, key) => (
                        <a key={ key } target={ child.link.target } href={ child.link.url }>
                            <li>
                                <span>{ child.link.title }</span>
                                <ArrowIcon theme="cream" right />
                            </li>
                        </a>
                    ))
                }
            </ul>
        </div>
    );

};

LoginMenuItem.propTypes = {
    collapsed: PropTypes.bool,
    gvars: PropTypes.object,
};

LoginMenuItem.defaultProps = {
    collapsed: false,
    gvars: {},
};

export default LoginMenuItem;
